<template>
    <v-content>
        <Header></Header>

        <div class="centro-bg-color" style="width: 100%; position: absolute;"
             :style="{ 'height': $vuetify.breakpoint.xs ? '310px':'400px' }"></div>

        <!-- Loading overlay -->
        <loading :active.sync="itemsLoaded" :is-full-page="true" loader="bars"></loading>

        <v-btn
            @click="$router.go(-1)"
            class="cursor-pointer"
            style="box-shadow: unset; background: transparent; margin-left: 40px; position: absolute; z-index: 1"
            :style="{ 'margin-top': $vuetify.breakpoint.mdAndUp ? '80px' : '20px' }">
            <v-icon color="#fff" large>arrow_back</v-icon>
            <span class="white--text">{{ $t('general.backToHome') }}</span>
        </v-btn>

        <v-layout justify-center style="position: relative;">
            <v-flex xs11 sm10 md8 lg7>
                <v-layout justify-center style="padding-top: 60px; padding-bottom: 32px">
                    <v-flex md8 lg7 text-center class="txt-head">
                        {{ $t('page.roomSelect.selectBuilding') }}
                    </v-flex>
                </v-layout>

                <v-layout justify-center mb-3>
                    <v-flex shrink>
                        <v-select
                                :items="allBuilding"
                                item-text="name"
                                item-value="id"
                                v-model="room.building"
                                @change="onSelectBuilding"
                                outlined
                                return-object
                                flat solo
                                menu-props="offsetY"
                        ></v-select>
                    </v-flex>
                </v-layout>

                <v-layout justify-center mb-3>
                    <v-flex>
                        <img style="width: 100%;" class="plan-img" :src="require('../assets/plan/flr-1.jpg')">
                    </v-flex>
                </v-layout>

                <div v-if="room.building.id !== null" id="level-select">

                    <v-layout justify-center pa-7 pt-12>
                        <v-flex md8 lg7 text-center class="txt-head">
                            {{ $t('page.roomSelect.selectLevel') }}
                        </v-flex>
                    </v-layout>

                    <v-layout justify-center mb-3>
                        <v-flex shrink>
                            <v-select
                                    :items="allLevel"
                                    v-model="room.level"
                                    @change="onSelectLevel"
                                    outlined flat
                                    return-object
                                    menu-props="offsetY"
                            ></v-select>
                        </v-flex>
                    </v-layout>

                    <div v-if="room.level.id" id="room-select">
                        <!-- Booking component -->
                        <v-layout justify-center mb-7>
                            <ImageGrid :image-data="imageGridData" :expect-width="1100"></ImageGrid>
                        </v-layout>
                    </div>
                </div>
            </v-flex>
        </v-layout>

        <h3 class="text-center mb-12">
            {{ $t('page.roomSelect.scrollableInfo') }}<br>
            {{ $t('page.roomSelect.scrollableInfo2') }}
        </h3>

        <div v-if="room.building.id">

            <div v-if="room.level.id">

                <div id="room-info" v-if="room.id">
                    <v-layout justify-center px-3 py-7 style="background-color: #E99B07">
                        <v-flex md10>
                            <div class="txt-head mb-5">
                                {{ $t('general.room') }}
                                {{ room.name }}
                                {{ $t('page.home.roomOffer.roomTypePrefix') }}
                                {{ room.room_type.name }}
                                {{ $t('general.level') }}
                                {{ room.level.name }}
                                {{ $t('general.building') }}
                                {{ room.building.name }}
                            </div>

                            <v-carousel>
                                <v-carousel-item
                                    v-for="(item, index) in room.room_type.gallery"
                                    :key="index"
                                    :src="item.image"></v-carousel-item>
                            </v-carousel>
                        </v-flex>
                    </v-layout>

                    <v-layout justify-center px-3 py-7>
                        <v-flex md8 lg7>
                            <div class="txt-semi-head" style="color: #44AB6F">
                                <v-icon large class="mr-3" color="#44AB6F">person_outline</v-icon>
                                {{ $t('page.roomSelect.view', {view: 2}) }}
                            </div>
                            <v-divider style="border-color: #000" class="my-5"></v-divider>
                            <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.roomDesign') }} : {{ room.room_type.data_object[`design_${language}`] }}</div>
                            <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.roomSize') }} : {{ room.size }} {{ $t('page.roomSelect.sqm') }}</div>
                            <!--<div class="txt-semi-head mb-5">{{ $t('page.roomSelect.roomView') }} : {{ room[`view_${language}`] }}</div>-->
                            <div class="txt-head centro-darkcolor mb-5">
                                {{ $t('general.price') }}
                                {{ room.price | numberFormat }}
                                {{ $t('general.baht') }}
                            </div>

                            <template v-if="room.promotion">
                                <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.promotionDescription') }} : {{ room.promotion.data_object[`${language}`] }}</div>
                            </template>
                            <div class="txt-semi-head mb-5">{{ $t('page.roomSelect.reserveText') }} {{ room.reserve_price | numberFormat }} {{ $t('general.baht') }}</div>
                        </v-flex>
                    </v-layout>

                    <v-layout justify-center mb-3>
                        <v-flex xs11>
                            <img class="image-border" :src="require('../assets/banner/typeselector_banner.png')">
                        </v-flex>
                    </v-layout>

                    <v-layout justify-center py-7 mb-5>
                        <v-flex xs10 md6>
                            <v-form
                                v-model="formValid"
                                ref="form">
                                <v-text-field
                                    v-model="reservationForm.name"
                                    :rules="nameRules"
                                    :placeholder="$t('form.name')"></v-text-field>
                                <v-text-field
                                    v-model="reservationForm.surname"
                                    :rules="surnameRules"
                                    :placeholder="$t('form.surname')"></v-text-field>
                                <v-text-field
                                    v-model="reservationForm.tel"
                                    :rules="telRules"
                                    :placeholder="$t('form.tel')"></v-text-field>
                                <v-text-field
                                    v-model="reservationForm.email"
                                    :rules="emailRules"
                                    :placeholder="$t('form.email')"></v-text-field>
                                <div class="text-center mt-5">
                                    <v-btn large style="border: solid 1px #C4C4C4"
                                           :disabled="!formValid"
                                           @click="$router.push({ name: 'Confirmation', params: { id: 1 } })">
                                        {{ $t('form.bookConfirm') }}
                                    </v-btn>
                                </div>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </div>

            </div>

        </div>

        <Footer></Footer>
    </v-content>
</template>

<script>
    import Footer from '../components/Footer'
    import Header from "../components/Header"
    import ImageGrid from '../components/ImageGrid.component'
    import {mapState, mapActions} from 'vuex'
    import Service from '../services'
    import Loading from 'vue-loading-overlay'
    import { required, email, maxLength, minLength, numberOnly } from '../utils/Validation.util'

    export default {
        name: 'TypeSelector',
        components: {
            Footer,
            Header,
            ImageGrid,
            Loading
        },
        data: () => ({
            bookingFlexWidth: null,
            itemsLoaded: false,

            formValid: false,
        }),
        computed: {
            ...mapState({
                language: state => state.locale.language,
                room: state => state.roomSelected.room,
                allBuilding: state => state.roomSelected.buildingList,
                allLevel: state => state.roomSelected.levelList.map(level => ({
                    ...level,
                    value: level.id,
                    text: level.name,
                    disabled: parseInt(level.active) === 2
                })),
                // allLevel: state => state.roomSelected.levelList,
                roomList: state => state.roomSelected.roomList,
                reservationForm: state => state.reservation.reservationForm,
            }),
            imageGridData: function () {
                return {
                    width: this.room.level.data_object.width,
                    height: this.room.level.data_object.height,
                    image: this.room.level.image,
                    rooms: this.roomList.map(room => room),
                }
            },
            nameRules: function () {
                return [
                    required(this._i18n.t('form.nameRequired')),
                ]
            },
            surnameRules: function () {
                return [
                    required(this._i18n.t('form.surnameRequired')),
                ]
            },
            emailRules: function () {
                return [
                    required(this._i18n.t('form.emailRequired')),
                    email(this._i18n.t('form.emailInvalid'))
                ]
            },
            telRules: function () {
                return [
                    required(this._i18n.t('form.telRequired')),
                    maxLength(10, this._i18n.t('form.telMaxLength', {num: 10})),
                    minLength(9, this._i18n.t('form.telMinLength', {num: 9})),
                    numberOnly(this._i18n.t('form.telNumberOnly'))
                ]
            },
        },
        async created() {
            this.itemsLoaded = true
            await this.recordedSender()
            await this.onGetAllBuilding()
            if (this.room.level.id) {
                await this.onGetAllRoomByLevel(this.room.level.id)
            }
            if (this.room.id) {
                await this.refreshRoomData()
            }
            this.itemsLoaded = false
        },
        methods: {
            ...mapActions('roomSelected', ['onGetAllBuilding', 'onGetAllLevelByBuilding', 'onGetAllRoomByLevel', 'onClearBooking', 'refreshRoomData']),
            recordedSender() {
                let data = {
                    user_activity_type_id: 1,
                    uuid: Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10) + '-' + Math.random().toString(36).substring(5, 10),
                    value: this.$route.path
                };
                Service.record.sendActivityData(data)
            },
            getBuildingList() {
                this.itemsLoaded = true;
                this.onGetAllBuilding().then(() => {
                    this.itemsLoaded = false;
                })
            },
            onSelectBuilding() {
                this.onClearBooking('building'); // for clear level & room id
                this.itemsLoaded = true;
                this.onGetAllLevelByBuilding(this.room.building.id).then(() => {
                    this.itemsLoaded = false;
                    this.$vuetify.goTo('#level-select');
                })
            },
            onSelectLevel() {
                this.onClearBooking('level'); // for clear room id
                this.itemsLoaded = true;
                this.onGetAllRoomByLevel(this.room.level.id).then(() => {
                    this.itemsLoaded = false;
                    this.$vuetify.goTo('#room-select');
                })
            }
        }

    }
</script>

<style scoped>

    .viewImage:hover {
        filter: brightness(30%);
        -webkit-filter: brightness(30%);
    }

    .v-card--reveal {
        align-items: center;
        bottom: 0;
        justify-content: center;
        opacity: 0.5;
        position: absolute;
        width: 100%;
        margin-bottom: 6px;
    }

</style>
